// // index.js
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import { Provider } from 'react-redux';
// import { store } from './store/store';
// import { loadState, saveState } from './store/localStorage';

// // Hydrate store from localStorage
// const persistedState = loadState();
// if (persistedState) {
//   store.dispatch({ type: 'form/hydrateBrandProfile', payload: persistedState });
// }

// // Subscribe to save state on changes
// store.subscribe(() => {
//   saveState(store.getState().form.brandProfile);
// });

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <Provider store={store}>
//     <App />
//   </Provider>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { hydrate } from './store/formSlice';
import { loadState, saveState } from './store/localStorage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

const persistedState = loadState();
if (persistedState) store.dispatch(hydrate(persistedState));

store.subscribe(() => saveState(store.getState().form));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

serviceWorkerRegistration.register();
